export const api_url = `${process.env.REACT_APP_SERVICE_API}/api/admin`
export const api_url_v1 = `${process.env.REACT_APP_SERVICE_API}/v1/admin`